import { Alert } from 'antd';
import React from 'react';
import { isSafeModeEnabled, SAFE_MODE_QUERY_PARAM } from '@tools/safeMode.ts';

const bannerStyle: React.CSSProperties = {
  padding: '8px 12px',
  position: 'sticky',
  top: 0,
  zIndex: 1100,
};

const SafeModeBanner: React.FC = () => {
  if (!isSafeModeEnabled()) {
    return null;
  }

  return (
    <div style={bannerStyle}>
      {/* Reason: surface safe-mode status so users know why optional scripts/features are disabled */}
      <Alert
        banner
        type="warning"
        showIcon
        title="Modo seguro activo"
        description={`Se inició con ?${SAFE_MODE_QUERY_PARAM}=1 para reducir cargas opcionales. Elimina ese parámetro de la URL para volver al modo completo.`}
      />
    </div>
  );
};

export default SafeModeBanner;
